module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-03-m.38f27263ac4d70f738627f47b12bdf60.png";